module.exports = __webpack_public_path__ + "assets/media/morning.11f556f6.mp3";